// TASK-314: mirrors imageAllowance.js/textAllowance.js — a pure helper the
// AI Assistant panel uses to show a locked state up front instead of
// rendering a chat input that would fail server-side (assistant_turns_monthly
// === 0 on the Scheduler/posting plan).
export function deriveAssistantAllowance(entitlements) {
  const allowance = entitlements?.usage?.assistant_turns_monthly;
  if (!allowance || typeof allowance.limit !== 'number' || !Number.isFinite(allowance.limit)) {
    return { known: false, limit: null, zero: false };
  }
  return { known: true, limit: allowance.limit, zero: allowance.limit === 0 };
}

// fix #7 (judge review): AIPanel used to lock ONLY on `allowance.zero`, which
// fails OPEN for a Scheduler org whenever entitlements have not been fetched
// yet (calendar/library screens never call ensureDashboardData) — the full
// chat renders and the first send 402s. This pure predicate is the single
// source of truth for "is the assistant allowed to render/act right now":
//  - allowance known: gate strictly on whether the limit is zero.
//  - allowance unknown but the check has completed (checked === true, i.e. the
//    ensureDashboardData() call settled — success or failure): FAIL OPEN to
//    the chat. A fetch error must never lock out a paying user.
//  - allowance unknown and the check has not completed yet: not allowed —
//    the caller renders a neutral "Checking your plan…" state instead of
//    either the chat or the locked copy.
export function assistantGate({ allowance, checked } = {}) {
  return allowance?.known ? !allowance.zero : Boolean(checked);
}
